/**
 * @file Counts the forms past due among My tasks: those whose due date is set
 * and late, the same rule that turns a My tasks due date red. Consumer:
 * `HomeNeedsMe`, whose "forms past due" row counts only the listed forms. A
 * form's state is not consulted, and a form due today is not yet past due.
 */
import type { HomeMyTask } from './HomeMyTasks.types';

export const homeOverdueForms = (tasks: readonly HomeMyTask[]): number =>
  tasks.filter(({ due }) => due.status === 'set' && due.late).length;
